module.exports = __webpack_public_path__ + "img/DownloadByGooglePlay.5a642df6.png";